module.exports = __webpack_public_path__ + "static/media/benefits-regional.bb2ae891.png";